"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isElement = exports.isFragment = exports.isElementOrFragment = void 0;
const react_1 = __importDefault(require("react"));
function isElementOrFragment(node) {
    return !!node && typeof node === "object" && "type" in node;
}
exports.isElementOrFragment = isElementOrFragment;
function isFragment(node) {
    return isElementOrFragment(node) && node.type === react_1.default.Fragment;
}
exports.isFragment = isFragment;
function isElement(node) {
    return isElementOrFragment(node) && node.type !== react_1.default.Fragment;
}
exports.isElement = isElement;
exports.default = isElement;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXMtZWxlbWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvdXRpbHMvaXMtZWxlbWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFBMEI7QUFFMUIsU0FBZ0IsbUJBQW1CLENBQUMsSUFBcUI7SUFDdkQsT0FBTyxDQUFDLENBQUMsSUFBSSxJQUFJLE9BQU8sSUFBSSxLQUFLLFFBQVEsSUFBSSxNQUFNLElBQUksSUFBSSxDQUFDO0FBQzlELENBQUM7QUFGRCxrREFFQztBQUVELFNBQWdCLFVBQVUsQ0FBQyxJQUFxQjtJQUM5QyxPQUFPLG1CQUFtQixDQUFDLElBQUksQ0FBQyxJQUFJLElBQUksQ0FBQyxJQUFJLEtBQUssZUFBSyxDQUFDLFFBQVEsQ0FBQztBQUNuRSxDQUFDO0FBRkQsZ0NBRUM7QUFFRCxTQUFnQixTQUFTLENBQUMsSUFBcUI7SUFDN0MsT0FBTyxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsSUFBSSxJQUFJLENBQUMsSUFBSSxLQUFLLGVBQUssQ0FBQyxRQUFRLENBQUM7QUFDbkUsQ0FBQztBQUZELDhCQUVDO0FBRUQsa0JBQWUsU0FBUyxDQUFDIn0=